// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../eachWeekendOfInterval/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var eachWeekendOfInterval = convertToFP(fn, 1);
export default eachWeekendOfInterval;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/eachWeekendOfInterval/index.js
// module id = 853
// module chunks = 0